import { DEFAULT_TIME_RANGE, type TimeRange } from "./TimeRange";

export interface TimelineState {
	lastSelectedDynamicInterval: TimeRange;
	timestampHistory: Array<number>;
}

export const initialTimelineState: TimelineState = {
	lastSelectedDynamicInterval: DEFAULT_TIME_RANGE,
	timestampHistory: [],
};
